export const setFSize = (size) => ({
  type: "SET_F_SIZE",
  payload: size,
});

export const setFFabric = (fabric) => ({
  type: "SET_F_FABRIC",
  payload: fabric,
});

export const setFColor = (color) => ({
  type: "SET_F_COLOR",
  payload: color,
});

export const setFSofaType = (corner) => ({
  type: "SET_F_SOFATYPE",
  payload: corner,
});
